export enum RouteEntityId {
  dashboard = 'dashboard',
  industryId = 'industryId',
  industryGroupId = 'industryGroupId',
  industrySubGroupId = 'industrySubGroupId',
  section = 'section',
}
